import { CcReviewReviewType } from "server/models"

export type CcReviewReviewTypeValidation = { [key in keyof CcReviewReviewType]?: string}
export interface CcReviewReviewTypeList { [typeId: number]: CcReviewReviewType }

export interface CcReviewReviewTypeState {
    typeList: CcReviewReviewTypeList
    typeIds: readonly number[]
    typeEdit: CcReviewReviewType

    reloadList: boolean
    reloadEdit: boolean
}

export const CC_REVIEW_REVIEW_TYPE_LIST = "CC_REVIEW_REVIEW_TYPE_LIST"
export const CC_REVIEW_REVIEW_TYPE_IDS = "CC_REVIEW_REVIEW_TYPE_IDS"
export const CC_REVIEW_REVIEW_TYPE_EDIT = "CC_REVIEW_REVIEW_TYPE_EDIT"

export const CC_REVIEW_REVIEW_TYPE_RELOAD_LIST = "CC_REVIEW_REVIEW_TYPE_RELOAD_LIST"
export const CC_REVIEW_REVIEW_TYPE_RELOAD_EDIT = "CC_REVIEW_REVIEW_TYPE_RELOAD_EDIT"
